package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.VerticalAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaCcStripe
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.core.AppTracking
import info.rezident.app.data.user.UserRepository
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun UnlockRecommendationsSection(
    creating: Boolean,
    onUnlock: () -> Unit,
    isCompleted: Boolean = false,
    priceText: String? = null,
    initialPriceText: String? = null,
    discountText: String? = null,
    paymentError: info.rezident.app.pages.recommendations.PaymentError? = null,
    source: String = "sidebar"
) {
    val userProfile = UserRepository.user.value
    val academicYear = userProfile?.academicYear ?: "unknown"
    val priceVariant = userProfile?.priceVariant?.name ?: "unknown"
    var isDiscountCodeExpanded: Boolean by remember { mutableStateOf(false) }
    // Track paywall view when component is first shown (only if not completed)
    LaunchedEffect(isCompleted) {
        if (!isCompleted) {
            AppTracking.logEvent(
                AppTracking.EVENT_RECOMMENDATIONS_PAYWALL_VIEW,
                mapOf(
                    AppTracking.PARAM_TEMPLATE_ID to 1,
                    "source" to source,
                    AppTracking.PARAM_ACADEMIC_YEAR to academicYear,
                    AppTracking.PARAM_PRICE_VARIANT to priceVariant
                )
            )
        }
    }

    // Unlock Premium section
    Box(
        modifier = Modifier
            .id("deblocheaza")
            .fillMaxWidth()
            .border(1.px, style = LineStyle.Solid, color = AppTheme.colors.accent)
            .backgroundColor(Color.transparent)
            .borderRadius(AppTheme.shapes.mediumRound)
            .padding(24.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            // Title with crown
            Row(
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.spacedBy(8.px),
                modifier = Modifier.margin(bottom = if (isCompleted) 8.px else 16.px)
            ) {
                SpanText(
                    text = "Analiză Detaliată",
                    modifier = AppTheme.typography.h2.toModifier()
                        .color(AppTheme.colors.text)
                )
            }

            if (!isCompleted) {
                // Benefits list
                Column(
                    modifier = Modifier.fillMaxWidth().margin(bottom = 14.px),
                    horizontalAlignment = Alignment.Start
                ) {
                    BenefitItem("Top 10 Recomandări - vezi de ce ți se potrivesc")
                    BenefitItem("Puncte Forte & Slabe - ce să păstrezi și să îmbunătățești")
                    BenefitItem("Specialități incompatibile - evită drumurile greșite")
                    BenefitItem("Actualizări incluse - primești îmbunătățiri pe viitor")
                }
            }

            if (!isCompleted) {
                SpanText(
                    "Fără abonament • Refund în 14 zile",
                    AppTheme.typography.body2.toModifier().color(AppTheme.colors.textSecondary)
                )

                Spacer(Modifier.height(16.px))

                // Price
                // SpanText(
                //     "Discount aplicat",
                //     AppTheme.typography.body2.toModifier().color(AppTheme.colors.error)
                // )

                Spacer(Modifier.height(3.px))

                Row(
                    Modifier.margin(bottom = 4.px).fillMaxWidth(),
                    verticalAlignment = Alignment.Top,
                    horizontalArrangement = Arrangement.Start
                ) {
                    if (priceText != null) {
                        // Show dynamic price from user's variant together with initial and discount
                        // Column {
                        //     if (!initialPriceText.isNullOrBlank()) {
                        //         SpanText(
                        //             text = initialPriceText,
                        //             AppTheme.typography.body2.toModifier()
                        //                 .color(AppTheme.colors.text)
                        //                 .margin(right = 8.px)
                        //                 .textDecorationLine(TextDecorationLine.LineThrough)
                        //         )
                        //     }

                        //     if (!discountText.isNullOrBlank()) {
                        //         Box(
                        //             modifier = Modifier
                        //                 .backgroundColor(AppTheme.colors.surface)
                        //                 .padding(leftRight = 4.px, topBottom = 2.px)
                        //                 .borderRadius(4.px),
                        //             contentAlignment = Alignment.Center
                        //         ) {
                        //             SpanText(
                        //                 text = discountText,
                        //                 AppTheme.typography.body2.toModifier()
                        //                     .color(AppTheme.colors.text)
                        //             )
                        //         }
                        //     }
                        // }

                        SpanText(
                            text = priceText,
                            AppTheme.typography.h2.toModifier()
                                .color(AppTheme.colors.error)
                        )
                    } else {
                        // Fallback to static pricing display
                        Column {
                            SpanText(
                                text = "49.99 RON",
                                AppTheme.typography.body2.toModifier()
                                    .color(AppTheme.colors.text)
                                    .textDecorationLine(TextDecorationLine.LineThrough)
                                    .margin(right = 8.px)
                            )

                            Box(
                                modifier = Modifier
                                    .backgroundColor(AppTheme.colors.background)
                                    .padding(leftRight = 4.px, topBottom = 2.px)
                                    .borderRadius(4.px),
                                contentAlignment = Alignment.Center
                            ) {
                                SpanText(
                                    text = "-50%",
                                    AppTheme.typography.body2.toModifier()
                                        .color(AppTheme.colors.text)
                                )
                            }
                        }

                        SpanText(
                            text = "24.99 RON",
                            AppTheme.typography.h2.toModifier()
                                .color(AppTheme.colors.error)
                        )
                    }
                }

                // Discount code info (expandable)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 16.px)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .cursor(Cursor.Pointer)
                            .onClick {
                                val next = !isDiscountCodeExpanded
                                AppTracking.logEvent(
                                    AppTracking.EVENT_RECOMMENDATIONS_DISCOUNT_CODE_CLICK,
                                    mapOf(
                                        AppTracking.PARAM_TEMPLATE_ID to 1,
                                        "source" to source,
                                        "action" to if (next) "expand" else "collapse",
                                        AppTracking.PARAM_ACADEMIC_YEAR to academicYear,
                                        AppTracking.PARAM_PRICE_VARIANT to priceVariant
                                    )
                                )
                                isDiscountCodeExpanded = next
                            },
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        SpanText(
                            text = "Ai un cod de reducere?",
                            modifier = AppTheme.typography.body2.toModifier()
                                .color(AppTheme.colors.textSecondary)
                        )
                    }

                    if (isDiscountCodeExpanded) {
                        SpanText(
                            text = "Introdu codul în pagina de plată pentru a aplica reducerea.",
                            modifier = AppTheme.typography.body2.toModifier()
                                .margin(top = 8.px)
                                .color(AppTheme.colors.textTertiary)
                        )
                    }
                }

                // Unlock button
                Button(
                    onClick = {
                        println("[UnlockSection] Button clicked")
                        // Log unlock button click with source
                        AppTracking.logEvent(
                            AppTracking.EVENT_RECOMMENDATIONS_UNLOCK_CLICK,
                            mapOf(
                                AppTracking.PARAM_TEMPLATE_ID to 1,
                                "source" to source,
                                AppTracking.PARAM_ACADEMIC_YEAR to academicYear,
                                AppTracking.PARAM_PRICE_VARIANT to priceVariant
                            )
                        )
                        println("[UnlockSection] Calling onUnlock()")
                        onUnlock()
                        println("[UnlockSection] onUnlock() returned")
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .backgroundColor(AppTheme.colors.accent)
                        .padding(4.px)
                        .borderRadius(AppTheme.shapes.mediumRound),
                    enabled = !creating
                ) {
                    SpanText(
                        text = when {
                            creating -> "Se încarcă..."
                            else -> "Deblochează"
                        },
                        modifier = AppTheme.typography.body1Medium.toModifier()
                            .color(AppTheme.colors.onAccent)
                    )
                }

                Spacer(Modifier.height(10.px))

                Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    Div {
                        SpanText(
                            "Plată securizată prin ",
                            AppTheme.typography.body2.toModifier()
                                .color(AppTheme.colors.textTertiary)
                                .padding(right = 2.px)
                        )
                        FaCcStripe(Modifier.verticalAlign(VerticalAlign.Middle), size = IconSize.XL)
                    }
                }

                if (!isCompleted && paymentError != null) {
                    // Show payment error if present
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(Color("#fee2e2"))
                            .border(1.px, style = LineStyle.Solid, color = Color("#ef4444"))
                            .borderRadius(8.px)
                            .padding(12.px)
                            .margin(topBottom = 16.px)
                    ) {
                        SpanText(
                            text = paymentError.message,
                            modifier = AppTheme.typography.body2.toModifier()
                                .color(Color("#991b1b"))
                                .textAlign(TextAlign.Center)
                        )
                    }
                }
            } else {
                // Success message for completed state
                SpanText(
                    text = "Felicitări! Acum poți vizualiza toate Recomandările Complete, bazate pe Quiz-ul de Orientare.",
                    modifier = AppTheme.typography.body1.toModifier()
                        .color(AppTheme.colors.text)
                        .margin(top = 8.px)
                )
            }
        }
    }
}

@Composable
private fun BenefitItem(text: String) {
    Row(
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.spacedBy(8.px),
        modifier = Modifier.margin(bottom = 8.px)
    ) {
        SpanText(
            text = "✓",
            modifier = Modifier
                .color(Color("#22c55e"))
                .fontSize(16.px)
        )
        SpanText(
            text = text,
            modifier = AppTheme.typography.body1.toModifier()
                .color(AppTheme.colors.textSecondary)
        )
    }
}
